<template>
  <div v-if="address" class="address-card">
    <AddressTravelDetails
      v-if="!noTravelDetails"
      :travel-time-airport="address.travelTimeAirport"
      :travel-time-mainstation="address.travelTimeMainstation"
      :location="location"
      class="address-card-travel-details"
    />
    <AddressAccessibility v-if="nid" :nid="nid" />
    <AddressMap
      v-if="location"
      :location="location"
      :title="title"
      class="address-card-map"
    />
    <div class="address-card-text text-prose">
      <AddressText :address="address.address" />
      <AddressLinks :address="address">
        <AddressGoogleMapsLink
          :address="address.address"
          :location="address.location"
        />
        <AddressZvvLink
          v-if="address.zvvStation"
          :station="address.zvvStation"
        />
      </AddressLinks>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AddressCardFragment } from '#graphql-operations'

const props = withDefaults(
  defineProps<{
    address?: AddressCardFragment
    noTravelDetails?: boolean
    title?: string
    nid?: string
  }>(),
  {
    address: undefined,
    noTravelDetails: false,
    title: '',
    nid: '',
  },
)

const location = computed(() => {
  if (!props.address) {
    return null
  }

  const value = props.address.manualLocation || props.address.location

  if (!value?.lat || !value.lon) {
    return null
  }

  return {
    lat: value.lat,
    lon: value.lon,
  }
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
.address {
  @apply not-italic;
}
.address-card {
  @apply grid;
  grid-template-columns: 1fr;
  grid-gap: var(--teaser-grid-gap);
  @variant desktop {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 1fr;
  }
}

.address-card-text {
  .address-links {
    @apply mt-size-5;
  }
}

@variant belowTablet {
  .address-card-map,
  .address-card-text {
    order: -1;
  }
}

.address-card-travel-details {
  @apply belowTablet:mb-size-7;
}

@variant desktop {
  .address-card-map {
    grid-column: 1;
    grid-row: 1;
  }
  .address-card-text {
    grid-column: 2;
    grid-row: 1 / 3;
  }
}
</style>
